<template>
  <router-link :to="path" v-slot="{ href, navigate, isActive }" custom>
    <li :class="[{ active: isActive }]">
      <a :href="href" @click="handleClick($event, navigate)">
        <span :class="['nav-icon', icon ? icon : '']"></span>
        <div class="nav-txt">{{ label }}</div>
      </a>
    </li>
  </router-link>
</template>

<script>
import { analytics } from "@/services/analytics.service";

export default {
  name: "NavLink",
  props: ["path", "label", "icon"],
  methods: {
    handleClick(event, navigate) {
      // Track navigation based on label
      const fromRoute = this.$route?.path || "";
      if (this.label === "Home") {
        analytics.navHomeClicked({ from_route: fromRoute });
      } else if (this.label === "Conversations") {
        analytics.navConversationsClicked({ from_route: fromRoute });
      } else if (this.label === "Favorites") {
        analytics.navFavoritesClicked({ from_route: fromRoute });
      }
      navigate(event);
    },
  },
};
</script>

<!-- <style scoped>
.active {
  font-weight: bold;
  color: #f16622;
  /* Example: Highlight active link */
}
</style> -->
